// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Loader-module-loader-JtlbO{height:100%;background-color:var(--des-color-fill-control-base);position:absolute;top:0;inset-inline:0;z-index:5;display:flex;justify-content:center;align-items:center}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loader": "Loader-module-loader-JtlbO"
};
export default ___CSS_LOADER_EXPORT___;
